import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from 'src/app/app'; // Corrected import

bootstrapApplication(AppComponent, appConfig) // Corrected component name
  .catch((err) => console.error(err));
